import React, {useContext} from 'react';
import {Route, Redirect} from 'react-router-dom';


export default function RegularRoute({...rest}) {

    return <Route {...rest}/>;
}
